import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach((table) => this.#formatTable(table));
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    if (table.parentElement?.classList.contains('rte-table-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const isArticleTable = Boolean(this.closest('.article-enhanced__content'));
    if (isArticleTable) {
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', table.querySelector('caption')?.textContent?.trim() || 'Tableau, défilement horizontal possible');
    }
    const parent = table.parentNode;
    if (parent) {
      if (isArticleTable) {
        const hint = document.createElement('p');
        hint.className = 'article-enhanced__table-hint';
        hint.textContent = 'Faites glisser le tableau pour voir les autres colonnes →';
        parent.insertBefore(hint, table);
      }
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
